// Copyright (c) Docugami, Inc. All rights reserved.

import { ITagText } from 'hooks/TagText';
import { MutableRefObject } from 'react';
import { MAX_TAG_LENGTH } from 'utils/TagStandardUtils';
import { HintInputField, IInputField } from './HintInputField';

export interface ChunkTagInputFieldProps {
    tagText: ITagText;
    inputRef?: MutableRefObject<IInputField | undefined>;
    disabled?: boolean;
    className?: string;
    small?: boolean;
}

export const ChunkTagInputField = (props: ChunkTagInputFieldProps) => {
    const { targetTags, recentTags, tagText, isEditing, setTagText, onEdit, isValid, accept, undo, chunkInstance, errorMessage } = props.tagText;

    return (
        <HintInputField
            className={props.className}
            disabled={props.disabled}
            inputRef={props.inputRef}
            value={tagText}
            placeholder={!!chunkInstance ? "UNLABELLED" : "NOTHING SELECTED"}
            isEditing={isEditing}
            onChange={v => setTagText(v)}
            onEdit={onEdit}
            onCancel={undo}
            isValid={() => isValid}
            maxLength={MAX_TAG_LENGTH}
            hints={[...targetTags, ...recentTags]}
            onAccept={accept}
            getErrorText={!!errorMessage ? () => errorMessage : undefined}
            fontSize={props.small ? '14px' : undefined} />
    )
}
